import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const Role = {
  BackendUser: "ADMINISTRADOR",
  //  ExecutiveUser: "EJECUTIVO",
  ClientUser: "CAJERO",
};

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/login",
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          meta: { authorize: [Role.BackendUser] },
          component: () => import("@/view/pages/Dashboard.vue"),
        },
        {
          path: "/comisiones",
          name: "comisiones",
          meta: { authorize: [Role.BackendUser] },
          component: () => import("@/view/pages/facturacionComision/FacturacionComision.vue"),
        },
        {
          path: "/detallesComisionesCorredor",
          name: "detallesComisionesCorredor",
          component: () => import("@/view/pages/facturacionComision/FacturacionComisionCorredor.vue"),
        },
        {
          path: "/usuarios",
          name: "usuarios",
          meta: { authorize: [Role.BackendUser] },
          component: () => import("@/view/pages/usuario/Usuarios.vue"),
        },
        {
          path: "/bancos",
          name: "bancos",
          meta: { authorize: [Role.BackendUser] },
          component: () => import("@/view/pages/banco/Banco.vue"),
        },
        {
          path: "/configuracion",
          name: "configuracion",
          meta: { authorize: [Role.BackendUser] },
          component: () => import("@/view/pages/configuracion/Configuracion.vue"),
        }
      ],
    },
    {
      path: "/error",
      name: "error",
      component: () => import("@/view/pages/error/Error.vue"),
      children: [
        {
          path: "error-1",
          name: "error-1",
          component: () => import("@/view/pages/error/Error-1.vue"),
        },
        {
          path: "error-2",
          name: "error-2",
          component: () => import("@/view/pages/error/Error-2.vue"),
        },
        {
          path: "error-3",
          name: "error-3",
          component: () => import("@/view/pages/error/Error-3.vue"),
        },
        {
          path: "error-4",
          name: "error-4",
          component: () => import("@/view/pages/error/Error-4.vue"),
        },
        {
          path: "error-5",
          name: "error-5",
          component: () => import("@/view/pages/error/Error-5.vue"),
        },
        {
          path: "error-6",
          name: "error-6",
          component: () => import("@/view/pages/error/Error-6.vue"),
        },
      ],
    },
    {
      path: "/",
      component: () => import("@/view/pages/auth/Auth"),
      children: [
        {
          name: "login",
          path: "/login",
          component: () => import("@/view/pages/auth/Login"),
        },
        {
          name: "external-login",
          path: "/external/:token",
          component: () => import("@/view/pages/auth/ExternalLogin"),
        },
        {
          name: "changePassword",
          path: "/changePassword/:token/view",
          component: () => import("@/view/pages/auth/ChangePassword"),
        },
        {
          name: "register",
          path: "/register",
          component: () => import("@/view/pages/auth/Register"),
        },
        {
          name: "recovery",
          path: "/recovery",
          component: () => import("@/view/pages/auth/Recovery"),
        },
        {
          name: "confirm",
          path: "/confirm/:token/view",
          component: () => import("@/view/pages/auth/RecoveryConfirm"),
        },
      ],
    },
    {
      path: "*",
      redirect: "/404",
    },
    {
      // the 404 route, when none of the above matches
      path: "/404",
      name: "404",
      component: () => import("@/view/pages/error/Error-1.vue"),
    },
  ],
});
